module.exports = __webpack_public_path__ + "img/achiote_menu4.6948cb34.png";